export function addClass(target: HTMLElement, name: string) {
    target.classList.add(name);
}

export function removeClass(target: HTMLElement, name: string) {
    target.classList.remove(name);
}

export function toggleClass(target: HTMLElement, name: string) {
    target.classList.toggle(name);
}

export function htmlEntites(text: string) {
    const list: Array<{
        re: RegExp;
        entity: string;
    }> = [
        { re: /&/g, entity: "&amp;" },
        { re: />/g, entity: "&gt;" },
        { re: /</g, entity: "&lt;" },
        { re: /"/g, entity: "&quot;" },
        { re: /á/g, entity: "&aacute;" },
        { re: /é/g, entity: "&eacute;" },
        { re: /í/g, entity: "&iacute;" },
        { re: /ó/g, entity: "&oacute;" },
        { re: /ú/g, entity: "&uacute;" },
    ];

    let t = text.slice();
    for (const { re, entity } of list) {
        t = t.replace(re, entity);
    }

    return text;
}
